import { Box, Typography } from '@mui/material';
import { ATSAutomationCreateTestIds } from 'data-testids/ATS';

import { CreateAutomationCTAButtons } from './components/CreateAutomationCTAButtons';
import { QuestionComboBox } from './components/QuestionComboBox';

export const CreateAutomation = () => {
  return (
    <Box data-testid={ATSAutomationCreateTestIds.CREATE_PANE}>
      <Typography data-testid={ATSAutomationCreateTestIds.APPLY_AUTOMATION_TEXT} sx={{ pb: 1 }}>
        Apply an automation to:
      </Typography>
      <QuestionComboBox onChange={() => {}} options={[]} />
      <CreateAutomationCTAButtons />
    </Box>
  );
};
